import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Files } from '../../../models/agents/files';
import swal from 'sweetalert2';
import { ImageViewerConfig } from 'ngx-image-viewer';
import { imageViewerOptions } from '../../../../assets/image-viewer-options';
import { NgxDocViewerComponent } from 'ngx-doc-viewer';
import { Store } from '@ngxs/store';
import { DisablePersonFile } from '../../../state-manager/actions/person-register.action';
import { DisableCompanyFile } from '../../../state-manager/actions/company-register.action';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PersonService } from '../../../services/person.service';
import { CompanyService } from '../../../services/company.service';
import { AgentFullRegistration } from '../../../models/agents/agent-full-registration';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-documents-list',
  templateUrl: './documents-list.component.html',
  styleUrls: [
    './documents-list.component.scss',
    '../../../../assets/icon/icofont/css/icofont.scss'
  ]
})
export class DocumentsListComponent implements OnInit {
  @Input() files: Array<Files>;
  @Input() registration: AgentFullRegistration;

  @Input() tipo: 'PF' | 'PJ';
  @Input() loading = false;
  @Input() fileStyle: 'normal' | 'simple' = 'normal';
  @Output() onDeleteFile = new EventEmitter<Files>();

  filterargs = { isDeleted: false };
  formGroupFile: FormGroup;
  filesModal: Array<Files>;
  fileDescription: Array<{}>;
  isFile: boolean;
  get notSimple(): boolean {
    return this.fileStyle !== 'simple';
  }
  filesGropedByType: [string, any][];

  // Image Viewer Configurator
  imageSrc = [];
  imageIndex = 0;
  config: ImageViewerConfig = imageViewerOptions;
  ngxDocComponent: NgxDocViewerComponent;

  // Document Viewer Configuration
  docSrc: string;

  constructor(
    protected store: Store,
    protected formBuilder: FormBuilder,
    protected personService: PersonService,
    protected companyService: CompanyService
  ) {
    this.initFormGroupKeyOptions();
  }

  ngOnInit() {
    this.filesModal = Array<Files>();
    this.files.map((row) => {
      this.filesModal.push(new Files(row));
    });
  }

  ngOnChanges() {
    if (this.files) {
      const arrayFiles = new Array<Files>();
      this.files.map((file) => arrayFiles.push(new Files(file)));
      this.imageSrc = arrayFiles.map((file) => file.fileUrl);
    }
  }

  formatDocumentDate(date: string): string {
    return moment.parseZone(date).format('DD/MM/YYYY');
  }

  getFileIcon(file: Files) {
    const extension = file.fileName.split('.').pop().toLowerCase();

    if (
      extension === 'jpeg' ||
      extension === 'jpg' ||
      extension === 'bmp' ||
      extension === 'gif' ||
      extension === 'png'
    ) {
      return 'icofont-file-jpg';
    } else if (extension === 'doc') {
      return 'icofont-file-doc';
    } else if (extension === 'pdf') {
      return 'icofont-file-pdf';
    } else {
      return 'icofont-file-file';
    }
  }

  disableFile(file: Files) {
    const index = this.files.indexOf(file);
    this.files.splice(index, 1);
    const tipo = this.tipo;
    if (tipo === 'PF') {
      this.store.dispatch(new DisablePersonFile(file));
    } else if (tipo === 'PJ') {
      this.store.dispatch(new DisableCompanyFile(file));
    }
    this.onDeleteFile.emit(file);
  }

  initFormGroupKeyOptions() {
    this.formGroupFile = this.formBuilder.group({
      fileUrl: this.formBuilder.control(false),
      fileName: this.formBuilder.control(false),
      fileType: this.formBuilder.control(false),
      isDeleted: this.formBuilder.control(false),
      documentDate: this.formBuilder.control(false)
    });
  }

  onChange(fileType, fileName) {
    const file = this.files.filter((file) => {
      return file.fileName === fileName;
    });

    const listFiles = this.files.filter((fl) => {
      return fl.fileName !== fileName;
    });

    const data: Files = {
      fileUrl: file[0].fileUrl,
      fileName: fileName,
      fileType: fileType,
      isDeleted: file[0].isDeleted,
      documentDate: file[0].documentDate
    };

    listFiles.push(new Files(data));

    // Atualizar arquivos da empresa
    if (this.registration.company) {
      this.companyService
        .updateFiles(this.registration.agent.id, listFiles)
        .subscribe(
          () => {
            this.loading = false;
            swal({
              title: 'Opções Compliance',
              text: 'Cadastro atualizado com sucesso.',
              type: 'success'
            }).catch(swal.noop);

            this.files = listFiles;
          },
          () => {
            swal({
              title: 'Opções Compliance',
              text:
                'Houve um erro ao atualizar o cadastro. Tente novamente mais tarde.',
              type: 'error'
            }).catch(swal.noop);
          }
        );
    }

    // Atualizar arquivos da pessoa
    if (this.registration.person) {
      // this.store.dispatch(new UpdatePersonFilesOnServer(this.registration.agent.id,listFiles));
      this.personService
        .updateFiles(this.registration.agent.id, listFiles)
        .subscribe(
          () => {
            this.loading = false;
            swal({
              title: 'Opções Compliance',
              text: 'Cadastro atualizado com sucesso.',
              type: 'success'
            }).catch(swal.noop);

            this.files = listFiles;
          },
          () => {
            swal({
              title: 'Opções Compliance',
              text:
                'Houve um erro ao atualizar o cadastro. Tente novamente mais tarde.',
              type: 'error'
            }).catch(swal.noop);
          }
        );
    }
  }

  downloadFile(file: Files) {
    this.loading = true;
    this.personService.downloadInvestorFile(file).subscribe(result => {
      const blob = new Blob([result], { type: result.type });

      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = file.fileName;
      link.click();
      this.loading = false;
    });
  }
}
